import React, { useEffect, Fragment } from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Scale, Sparkles, HeartHandshake } from 'lucide-react';
const stories = [{
  icon: TrendingUp,
  category: 'Organizational Growth',
  title: 'Revitalizing a Statewide Medical Association',
  challenge: 'Stagnant membership and limited program revenue threatened long-term sustainability.',
  result: 'Drove 312% revenue growth and expanded the foundation, scholarships, and member programs.'
}, {
  icon: Scale,
  category: 'Advocacy Victory',
  title: 'Advancing Landmark Healthcare Legislation',
  challenge: 'Competing interests stalled critical physician and patient protection policy.',
  result: 'Built a bipartisan coalition that secured passage of priority legislation after multiple sessions.'
}, {
  icon: Sparkles,
  category: 'Healthcare Transformation',
  title: 'Modernizing Operations & Member Experience',
  challenge: 'Legacy systems and processes limited responsiveness and engagement.',
  result: 'Led a transformation initiative that modernized operations and elevated member satisfaction.'
}, {
  icon: HeartHandshake,
  category: 'Partnership Development',
  title: 'Building Cross-Sector Healthcare Partnerships',
  challenge: 'Fragmented stakeholders limited collective impact on workforce challenges.',
  result: 'Forged partnerships across providers, payers, and policymakers to launch workforce programs.'
}];
export function SuccessStories() {
  useEffect(() => {
    document.title = 'Success Stories | Michelle McOmber Leadership Case Studies';
  }, []);
  return <div className="w-full bg-white" data-id="element-451">
      <header className="bg-navy-900 text-white py-20" data-id="element-452">
        <div className="max-w-7xl mx-auto px-6" data-id="element-453">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-454">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-455">
              Success Stories
            </h1>
            <p className="text-xl text-slate-300 max-w-2xl" data-id="element-456">
              Executive leadership case studies in growth, advocacy,
              transformation, and partnership.
            </p>
          </motion.div>
        </div>
      </header>

      <section className="py-20" data-id="element-457">
        <div className="max-w-6xl mx-auto px-6 space-y-10" data-id="element-458">
          {stories.map((s, i) => <motion.article key={s.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.06
        }} className="grid grid-cols-1 md:grid-cols-3 gap-8 bg-slate-50 rounded-xl p-8 md:p-10" data-id="element-459">
              <div data-id="element-460">
                <div className="w-14 h-14 bg-navy-900 text-white rounded-lg flex items-center justify-center mb-4" data-id="element-461">
                  <s.icon className="w-7 h-7" data-id="element-462" />
                </div>
                <span className="text-gold font-semibold text-sm uppercase tracking-wide" data-id="element-463">
                  {s.category}
                </span>
                <h2 className="text-2xl font-serif font-bold text-navy-900 mt-2" data-id="element-464">
                  {s.title}
                </h2>
              </div>
              <div className="md:col-span-2 space-y-6" data-id="element-465">
                <div data-id="element-466">
                  <p className="text-sm font-bold text-navy-900 uppercase tracking-wide mb-1" data-id="element-467">
                    Challenge
                  </p>
                  <p className="text-slate-600 leading-relaxed" data-id="element-468">
                    {s.challenge}
                  </p>
                </div>
                <div data-id="element-469">
                  <p className="text-sm font-bold text-gold uppercase tracking-wide mb-1" data-id="element-470">
                    Result
                  </p>
                  <p className="text-slate-700 leading-relaxed font-medium" data-id="element-471">
                    {s.result}
                  </p>
                </div>
              </div>
            </motion.article>)}
        </div>
      </section>
    </div>;
}